import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { products } from '../../data/products';
import { ProductCard } from '../products/ProductCard';
import { useTranslation } from '../../lib/i18n';
interface ProductShowcaseProps {
  onRequestQuote: (productId: string) => void;
}
export function ProductShowcase({
  onRequestQuote
}: ProductShowcaseProps) {
  const {
    t,
    lang
  } = useTranslation();
  const showcaseProducts = [products.find(p => p.id === 'sca'), products.find(p => p.id === 'standard'), products.find(p => p.id === 'raptor')].filter(Boolean) as typeof products;
  return <section id="products" className="py-12 md:py-20 bg-dark-bg" data-id="element-252">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-253">
        <div className="text-center mb-8 md:mb-12" data-id="element-254">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-brand-yellow mb-3 md:mb-4" data-id="element-255">
            {t.showcase.titleHighlight}
          </h2>
        </div>
        <div className="space-y-6 md:space-y-10" data-id="element-256">
          {showcaseProducts.map(product => <ProductCard key={product.id} product={product} layout="horizontal" onRequestQuote={onRequestQuote} data-id="element-257" />)}
        </div>
        <div className="mt-10 text-center" data-id="element-258">
          <Link to="/products" className="inline-flex items-center gap-2 text-brand-yellow hover:text-white transition-colors font-semibold text-sm border border-brand-yellow/30 hover:border-brand-yellow/60 rounded-lg px-5 py-3" data-id="element-259">
            {lang === 'en' ? 'View all models' : lang === 'ru' ? 'Посмотреть все модели' : 'Pogledajte sve modele'}
            <ArrowRightIcon className="w-4 h-4" data-id="element-260" />
          </Link>
        </div>
      </div>
    </section>;
}